module.exports = __webpack_public_path__ + "img/5.d4c4ffd2.png";